<section class="carousel-products">
    <div class="carousel-products__title">
      <h2 class="page-title">{{ title() }}</h2>
      <button class="btn--icon--sm" aria-label="show more">
        Види повеќе
        <img class="btn__logo--right" src="icons/right-arrow.png" alt="show more icon" />
      </button>
    </div>
    <swiper-container #swiperContainer
      init="false"
      (onSliderMove)="changeHandler()"
      (onReachEnd)="endHandler()"
      (onReachBeginning)="beginHandler()">
    <!--    [pagination]="{ clickable: true }"
      [navigation]="true"
      [slidesPerView]="slidesToShow() ? slidesToShow() : 3"
      [spaceBetween]="0" -->
    <!-- (swiper)="onSwiper($event)"
      (slideChange)="onSlideChange()" -->
      @for(product of products(); track product.id) {
        <swiper-slide>
          <app-product-card [product]="product"></app-product-card>
        </swiper-slide>
      }
      
      <!-- <button
        #nextBtn
        class="carousel-products__next"
        (click)="onNextClick()"
        aria-label="show more"
      >
        <img src="icons/right-arrow.png" alt="right icon" />
      </button>
      <button
        #prevBtn
        class="carousel-products__prev"
        (click)="onPrevClick()"
        aria-label="show more"
      >
        <img src="icons/left-arrow.png" alt="left icon" />
      </button> -->
    </swiper-container>
</section>
